/**
 * ч.766: попап «обрати» біля ПДФО / ВЗ / ЄСВ у зарплатній платіжці — сплачені
 * платіжки податків організації з пошуком і фільтром за датами (податки могли
 * бути сплачені давно / іншою платіжкою).
 */
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { bankPayments, type TaxCandidate } from '@/api/bankDocs';
import DatePopover from '@/components/DatePopover';
import { TAX_LINK_LABEL, type TaxLinkType } from '@/shared/taxLinksPurpose';
import TchTable from '@/shared/components/TchTable';

export default function TaxPoPicker(props: {
  organizationId: string;
  taxType: TaxLinkType;
  onPick: (c: TaxCandidate) => void;
  onClose: () => void;
}) {
  const { organizationId, taxType, onPick, onClose } = props;
  const [q, setQ] = useState('');
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const listQ = useQuery({
    queryKey: ['tax-po-picker', organizationId, q, from, to],
    queryFn: () => bankPayments.taxCandidates({
      organization_id: organizationId, posted: true, q: q || undefined,
      date_from: from ? `${from}T00:00:00` : undefined, date_to: to ? `${to}T23:59:59` : undefined,
    }),
  });
  const rows = (listQ.data ?? []).filter((c) => !c.tax_type || c.tax_type === taxType);
  const fmt = (n: string) => Number(n).toLocaleString('uk-UA', { minimumFractionDigits: 2 });
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'var(--overlay)', zIndex: 60,
      display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={onClose}>
      <div className="card" style={{ width: 760, maxWidth: '95vw', padding: '1rem', maxHeight: '85vh', overflow: 'auto' }}
        onClick={(e) => e.stopPropagation()}>
        <div className="toolbar" style={{ marginBottom: '0.5rem' }}>
          <h3 style={{ margin: 0 }}>Сплачені платіжки: {TAX_LINK_LABEL[taxType]}</h3>
          <button type="button" style={{ marginLeft: 'auto' }} onClick={onClose}>закрити</button>
        </div>
        <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', marginBottom: '0.5rem' }}>
          <input type="search" placeholder="№, отримувач, призначення" value={q}
            onChange={(e) => setQ(e.target.value)} style={{ flex: 1 }} />
          <DatePopover value={from} onChange={setFrom} />
          <DatePopover value={to} onChange={setTo} />
        </div>
        {rows.length === 0 && <p style={{ color: 'var(--muted)' }}>Нічого не знайдено.</p>}
        {rows.length > 0 && (
          <TchTable>
            <thead>
              <tr><th style={{ width: 90 }}>№</th><th style={{ width: 100 }}>Дата</th><th>Отримувач</th>
                <th className="num" style={{ width: 120 }}>Сума</th><th style={{ width: 80 }}></th></tr>
            </thead>
            <tbody>
              {rows.map((c) => (
                <tr key={c.id}>
                  <td>{c.document_number}</td>
                  <td>{c.document_date ? new Date(c.document_date).toLocaleDateString('uk-UA') : ''}</td>
                  <td>{c.recipient_name ?? '—'}</td>
                  <td style={{ textAlign: 'right' }}>{fmt(c.amount)}</td>
                  <td style={{ textAlign: 'right' }}>
                    <button type="button" className="primary" onClick={() => { onPick(c); onClose(); }}>обрати</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </TchTable>
        )}
      </div>
    </div>
  );
}
